import dayjs from 'dayjs';

// Vreme uz svaki baloncic: danas -> "HH:mm", inace "DD.MM.YYYY HH:mm".
export const formatMessageTime = (value) => {
  if (!value) return '';
  const date = dayjs(value);
  if (!date.isValid()) return '';
  return date.isSame(dayjs(), 'day')
    ? date.format('HH:mm')
    : date.format('DD.MM.YYYY HH:mm');
};

// Kompaktno vreme za listu razgovora: danas -> "HH:mm", ova godina -> "DD.MM.",
// inace "DD.MM.YYYY".
export const formatConversationTime = (value) => {
  if (!value) return '';
  const date = dayjs(value);
  if (!date.isValid()) return '';
  if (date.isSame(dayjs(), 'day')) return date.format('HH:mm');
  if (date.isSame(dayjs(), 'year')) return date.format('DD.MM.');
  return date.format('DD.MM.YYYY');
};
